import { Route, Routes } from "react-router-dom";

import { Acolitos, DetallesAcolito, NuevoAcolito, Ausencias } from "../pages";

export const AcolitosRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Acolitos />} />
      <Route path="/nuevo" element={<NuevoAcolito />} />
      <Route path="/ausencias" element={<Ausencias />} />
      <Route path="/:id" element={<DetallesAcolito />} />
    </Routes>
  );
};
